import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HighlightPipeModule } from '@schoolbelle/shared/pipes';

import { TextViewerModule } from '../text-viewer/index';
import { LetterTagsModule } from '../letter-tags/index';
import { LetterSurveyButtonModule } from '../letter-survey-button/index';
import { LetterFilelistModule } from '../letter-filelist/index';
import { MediaBrowserModule } from '../media-browser/index';
import { LetterNewBadgeModule } from '../letter-new-badge/index';
import { LetterContentModule } from '../letter-content/index';
import { LetterMetadataModule } from '../letter-metadata/index';

import { LetterItemComponent } from './letter-item.component';
import { TranslationViewerModule } from '../translation-viewer/index';
import { TranslationDropdownModule } from '../translation-dropdown/index';

@NgModule({
  declarations: [LetterItemComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    RouterModule,
    TextViewerModule,
    TranslationViewerModule,
    TranslationDropdownModule,

    HighlightPipeModule,
    LetterTagsModule,
    LetterNewBadgeModule,
    LetterMetadataModule,
    LetterSurveyButtonModule,
    LetterFilelistModule,
    LetterContentModule,
    MediaBrowserModule,
  ],
  exports: [
    CommonModule,
    BsDropdownModule,
    RouterModule,
    TextViewerModule,
    TranslationViewerModule,
    TranslationDropdownModule,
    HighlightPipeModule,
    LetterTagsModule,
    LetterNewBadgeModule,
    LetterMetadataModule,
    LetterSurveyButtonModule,
    LetterFilelistModule,
    LetterContentModule,
    MediaBrowserModule,
  ]
})
export class LetterItemModule { }
